import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
// import styled from 'styled-components'

import BackgroundImage from 'gatsby-background-image'

export const BackgroundSection = (props) => {

  const data = useStaticQuery(
    graphql`
      query {
        background1: file(relativePath: { eq: "main/back1.png" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        },
        background2: file(relativePath: { eq: "main/back2.png" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )

  const imageData = data[props.image || 'background1'].childImageSharp.fluid

  return (
    <BackgroundImage
      Tag="div"
      fluid={imageData}
      {...props}
    />
  )
}


export default BackgroundSection